var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "288.7 241.9 561 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED474B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.86,311.22c-21.22,0-38.48-17.26-38.48-38.48,0-16.97-13.81-30.78-30.78-30.78s-30.78,13.81-30.78,30.78,13.59,30.53,30.32,30.78c.36-.02.71-.02,1.05,0,17.67.23,32.82,12.4,36.87,29.63.68,2.86,1.02,5.84,1.02,8.85.02,16.98,13.83,30.78,30.78,30.78s30.78-13.81,30.78-30.78-13.81-30.78-30.78-30.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.86,241.96c-16.97,0-30.78,13.81-30.78,30.78s13.81,30.78,30.78,30.78,30.78-13.81,30.78-30.78-13.81-30.78-30.78-30.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.99,311.22h-.75c-2.18.02-4.45.29-6.7.82-16.51,3.89-26.79,20.5-22.89,37.02,1.89,8,6.78,14.79,13.78,19.11,6.99,4.32,15.25,5.66,23.24,3.77,13.97-3.29,23.72-15.59,23.72-29.92v-.02c0-2.41-.28-4.79-.82-7.08-3.25-13.82-15.41-23.56-29.58-23.7Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.37,252.23c26.25,0,39.9,11.7,39.9,30.45,0,10.05-4.05,18-11.85,23.4,12.75,5.1,18.3,14.55,18.3,27.75,0,21.15-15.15,33.9-43.8,33.9h-54.15v-115.5h51.6ZM343.37,297.38c6.9,0,13.5-3.3,13.5-10.5,0-7.65-6.3-10.65-13.35-10.65h-17.7v21.15h17.55ZM345.17,343.27c8.85,0,15.6-4.05,15.6-11.7s-6.75-12.15-15.6-12.15h-19.35v23.85h19.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.77,252.23c30,0,48.3,17.55,48.3,43.05s-18.3,42-48.3,42h-12.75v30.45h-31.05v-115.5h43.8ZM443.87,313.27c9.9,0,17.1-6.45,17.1-18s-7.2-17.85-17.1-17.85h-11.85v35.85h11.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.41,252.23l43.05,115.5h-32.25l-6.15-18.15h-43.65l-6.15,18.15h-31.05l43.05-115.5h33.15ZM550.36,324.07l-13.2-38.85-13.2,38.85h26.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.72,252.23c37.65,0,59.7,22.35,59.7,57.75s-22.05,57.75-59.7,57.75h-41.7v-115.5h41.7ZM637.52,338.77c18,0,28.95-11.4,28.95-28.8s-10.95-28.8-28.95-28.8h-9.45v57.6h9.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpadLogo);
export default __webpack_public_path__ + "static/media/bpad-logo.d859766d17f26cf6e253b6f3a17e8356.svg";
export { ForwardRef as ReactComponent };